<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <Loader v-if="loading"/>
        <div class="d-flex justify-content-center align-items-center center-page-content" v-else>
          <div class="user-cta">
            <Icon name="grAlertTriangle" width="36" class="mb-3"/>
            <div class="mb-5">
              <h4 class="user-cta__title">{{ $t('fotosmile.error_title') }}</h4>
              <h5 class="user-cta__subtitle">{{ $t('fotosmile.error_subtitle') }}</h5>
            </div>
            <b-button class="user-cta__action" variant="primary" :href="contactUrl" target="_blank">
              {{ $t('fotosmile.contact_us') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import Loader from "@/components/Loader.vue";
import {getContactUrl} from "@/utils";
import FotosmileService from "@/services/Fotosmile";
import {
  saveFotosmileParams,
  getFotosmileParams,
  clearFotosmileParams,
} from "@/domain/fotosmile/storage";

export default {
  name: 'FotosmileEntry',
  components: {Loader},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    contactUrl() {
      return getContactUrl()
    },
  },
  async mounted() {
    await this.handleRedirect()
  },
  methods: {
    async handleRedirect() {
      const token = this.$route.query.d || getFotosmileParams().token
      const apiKey = this.$route.query.k || getFotosmileParams().apiKey

      if (!token || !apiKey) {
        this.showError()
        return
      }

      // Bridge the params across the login round-trip / page reloads.
      saveFotosmileParams(token, apiKey)

      if (!this.isAuthenticated) {
        // The user must be recognised by GetPica: only the logged-in identity
        // determines who the scan/unlock applies to. Resume happens from the
        // checkins-list guard once authentication completes.
        await this.$router.push({name: 'login'})
        return
      }

      await this.dispatchEvent(token, apiKey)
    },

    async dispatchEvent(token, apiKey) {
      try {
        const {data} = await FotosmileService.sendEvent(token, apiKey)
        clearFotosmileParams()
        this.routeByEvent(data)
      } catch (error) {
        clearFotosmileParams()
        if (error.response && error.response.status === 401) {
          await this.$router.push({name: 'login'})
          return
        }
        this.showError()
      }
    },

    routeByEvent(data) {
      if (data.event === 'pass_scan') {
        // Continue the normal GetPica completion flow (selfie upload) using the
        // returned pending picacode, reusing the checkins-list bridge. The pass
        // validity seeds the date-of-stay used during check-in completion.
        this.seedDateOfStay(data.valid_from, data.valid_to)
        sessionStorage.setItem('picacode', data.picacode)
        this.$router.push({name: 'checkins-list'})
      } else if (data.event === 'media_unlock' && data.is_unlocked) {
        this.goToUnlockedPhoto(data)
      } else {
        this.showError()
      }
    },

    seedDateOfStay(start, end) {
      if (!start || !end) return
      this.$store.commit('SET_DATE_OF_STAY', {start, end})
      // Survive the full page reload before /complete-checkin (see store/index.js)
      sessionStorage.setItem('dateOfStay', JSON.stringify({start, end}))
    },

    goToUnlockedPhoto(data) {
      const route = data.picacode
          ? {name: 'checkins-detail', params: {picacode: data.picacode}}
          : {name: 'checkins-list'}
      this.$router.push(route)
      // Toast on the root instance so it survives this component unmounting.
      window.vueApp.$bvToast.toast(this.$t('fotosmile.unlocked_message'), {
        title: this.$t('fotosmile.unlocked_title'),
        variant: 'success',
        autoHideDelay: 5000,
      })
    },

    showError() {
      this.loading = false
    },
  },
}
</script>
<style>
.site-banner {
  display: none !important;
}

</style>
